import { Injectable } from '@angular/core';
import { PermissionContext } from 'src/app/model';
import { PermissionsEnum } from 'src/app/model/common/permissions.enum';

@Injectable({
  providedIn: 'root'
})
export class ReturnPermissionService {
  setPermissions(userPermissions: any): PermissionContext {
    return {
      canApprovePreparation: this.hasPermission(userPermissions, PermissionsEnum.confirmReturnPreparation),
      canApproveReview: this.hasPermission(userPermissions, PermissionsEnum.confirmReturnReview),
      canApproveSignerReview: this.hasPermission(userPermissions, PermissionsEnum.confirmSignerReview),
      canApproveClientApproval: this.hasPermission(userPermissions, PermissionsEnum.confirmClientApproval),
      canApproveEFiling: this.hasPermission(userPermissions, PermissionsEnum.confirmEFiling),
      canApproveConfirmationReview: this.hasPermission(userPermissions, PermissionsEnum.confirmPaymentsReview),
    };
  }

  resetPermissions(): PermissionContext {
    return {
      canApprovePreparation: false,
      canApproveReview: false,
      canApproveSignerReview: false,
      canApproveClientApproval: false,
      canApproveEFiling: false,
      canApproveConfirmationReview: false,
    };
  }

  private hasPermission(userPermissions: any, requiredPermission: PermissionsEnum): boolean {
    if (Array.isArray(userPermissions)) {
      return userPermissions.includes(requiredPermission);
    }
    if (typeof userPermissions === 'object') {
      return userPermissions[requiredPermission] === true;
    }
    return false;
  }
}
